import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LinkIcon, MailIcon } from '@ui/custom-icons';
import { BackgroundCard } from '../BackgroundCard';
import { Link } from '../Link';
export function SocialsBox(param) {
    let { email, socialAccounts } = param;
    return /*#__PURE__*/ _jsx(BackgroundCard, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-2 max-w-[300px] text-muted-foreground",
            "data-e2e": "socials-card",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "text-base leading-[1.5] font-bold",
                        "data-e2e": "socials-card-title",
                        children: "Socials"
                    })
                }),
                !!email && /*#__PURE__*/ _jsxs("div", {
                    className: "flex flex-row gap-2 items-center",
                    "data-e2e": "socials-card-email",
                    children: [
                        /*#__PURE__*/ _jsx(MailIcon, {
                            color: "#27584D",
                            width: 16,
                            height: 16,
                            "data-e2e": "socials-card-email-icon"
                        }),
                        /*#__PURE__*/ _jsx("a", {
                            className: "text-white break-all max-w-[85%] no-underline",
                            href: "mailto:".concat(email),
                            target: "_blank",
                            "data-e2e": "socials-card-email-link",
                            children: email
                        })
                    ]
                }),
                !!socialAccounts && socialAccounts.map((item)=>/*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-row gap-2 items-center",
                        "data-e2e": "socials-card-social-link-container",
                        children: [
                            /*#__PURE__*/ _jsx(LinkIcon, {
                                color: "#27584D",
                                width: 16,
                                height: 16,
                                "data-e2e": "socials-card-social-link-icon"
                            }),
                            /*#__PURE__*/ _jsx(Link, {
                                className: "white break-all max-w-[85%] no-underline",
                                href: item.link,
                                target: "_blank",
                                "data-e2e": "socials-card-social-link-text",
                                children: item.label
                            })
                        ]
                    }, item.label + '_social-link'))
            ]
        })
    });
}
